import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Eye, EyeOff, Pencil, Trash2, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/api/admin/courses").then(({data}) => setCourses(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const togglePub = async (c) => {
    const url = c.is_published ? `/api/admin/courses/${c.id}/unpublish` : `/api/admin/courses/${c.id}/publish`;
    await api.post(url);
    toast.success(c.is_published ? "Unpublished" : "Published");
    load();
  };

  const remove = async (c) => {
    if (!window.confirm(`Delete '${c.title}'? This cannot be undone.`)) return;
    await api.delete(`/api/admin/courses/${c.id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-courses">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="label-eyebrow">Courses</div>
          <h1 className="font-display font-black text-3xl mt-1">All courses</h1>
        </div>
        <Link to="/admin/ai-generator" data-testid="cta-generate" className="btn-primary flex items-center gap-1">
          <Sparkles className="w-4 h-4" /> Generate with AI
        </Link>
      </div>

      {loading ? <div>Loading...</div> : (
        <div className="bg-white border border-[#E5E7EB] rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[#F3F4F6]">
              <tr>
                <th className="px-4 py-3 text-left">Title</th>
                <th className="px-4 py-3 text-left">Category</th>
                <th className="px-4 py-3 text-left">Level</th>
                <th className="px-4 py-3 text-left">Price</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Source</th>
                <th className="px-4 py-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {courses.map((c) => (
                <tr key={c.id} className="border-t border-[#E5E7EB]">
                  <td className="px-4 py-3 font-semibold">{c.title}</td>
                  <td className="px-4 py-3 text-[#4B5563]">{c.category_name}</td>
                  <td className="px-4 py-3 text-[#4B5563]">{c.level}</td>
                  <td className="px-4 py-3">${c.price_usd}</td>
                  <td className="px-4 py-3">
                    <span className={`text-xs font-bold uppercase px-2 py-1 rounded ${c.is_published ? "bg-[#064E3B]/10 text-[#064E3B]" : "bg-[#F3F4F6] text-[#4B5563]"}`}>
                      {c.is_published ? "Published" : "Draft"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-[#4B5563]">{c.source}</td>
                  <td className="px-4 py-3 text-right">
                    <div className="inline-flex gap-2">
                      <button title={c.is_published ? "Unpublish" : "Publish"} onClick={() => togglePub(c)} data-testid={`toggle-${c.id}`} className="p-1.5 hover:bg-[#F3F4F6] rounded">
                        {c.is_published ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                      </button>
                      <Link to={`/admin/courses/${c.id}`} title="Edit" data-testid={`edit-${c.id}`} className="p-1.5 hover:bg-[#F3F4F6] rounded inline-flex">
                        <Pencil className="w-4 h-4" />
                      </Link>
                      <button title="Delete" onClick={() => remove(c)} data-testid={`delete-${c.id}`} className="p-1.5 hover:bg-[#FEE2E2] rounded">
                        <Trash2 className="w-4 h-4 text-[#DC2626]" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
